import type { SagaIterator } from "redux-saga";
import { call, put, select, takeEvery } from "redux-saga/effects";
import { getType } from "typesafe-actions";

import * as servicesApi from "@/shop/api/services";
import type { IServiceObject } from "@/shop/types/services";

import * as ServicesActions from "./actions";
import type { ServicesAction } from "./reducer";
import { getServicesExists } from "./selectors";

function* fetchServices(_: ServicesAction): SagaIterator {
  try {
    const servicesExists = (yield select(getServicesExists)) as boolean;

    if (servicesExists) {
      return;
    }

    yield put(ServicesActions.fetchServicesStart());

    const services = (yield call(servicesApi.fetchServicesInformation)) as IServiceObject[];
    yield put(ServicesActions.fetchServicesSuccess({ services }));
  } catch {
    yield put(ServicesActions.fetchServicesFail());
  }
}

export default function* servicesSaga(): SagaIterator {
  yield takeEvery(getType(ServicesActions.fetchServices), fetchServices);
}
